const STORAGE_KEY = "async_roleplay_active_session";

export type StoredAsyncRoleplaySession = {
  sessionId: string;
  recordId: string;
  domain: string;
  focus: string;
  windowTitle?: string | null;
  persona?: string | null;
  personaAvatar?: string | null;
  savedAt: number;
};

export const saveAsyncRoleplaySession = (
  session: Omit<StoredAsyncRoleplaySession, "savedAt">,
): void => {
  try {
    const payload: StoredAsyncRoleplaySession = {
      ...session,
      savedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
};

export const loadAsyncRoleplaySession = (): StoredAsyncRoleplaySession | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAsyncRoleplaySession;
    if (!parsed?.sessionId || !parsed?.recordId) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearAsyncRoleplaySession = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
